import moment from 'moment';

type WithDatetime = {
  datetime: string;
};

export const datetimeSort = <T extends WithDatetime>(a: T, b: T) =>
  moment(b.datetime).diff(moment(a.datetime));
